import styled, { css } from 'styled-components';
import { WrapperProps } from './types';

const Wrapper = styled.div<WrapperProps>`
  width: 120px;

  ${({ $isContracted }) =>
    $isContracted &&
    css`
      width: 31px;
      overflow: hidden;
    `}
`;

export default Wrapper;
